import React from "react";

const Plus = () => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{ mixBlendMode: "luminosity" }}>
        <path
          d="M7 14.0156C7.49219 14.0156 7.89062 13.6094 7.89062 13.1484V8.25781H12.6562C13.1328 8.25781 13.5391 7.85938 13.5391 7.36719C13.5391 6.88281 13.1328 6.47656 12.6562 6.47656H7.89062V1.58594C7.89062 1.11719 7.49219 0.71875 7 0.71875C6.51562 0.71875 6.10938 1.11719 6.10938 1.58594V6.47656H1.34375C0.882812 6.47656 0.460938 6.88281 0.460938 7.36719C0.460938 7.85938 0.882812 8.25781 1.34375 8.25781H6.10938V13.1484C6.10938 13.6094 6.51562 14.0156 7 14.0156Z"
          fill="#797979"
        />
      </g>
    </svg>
  );
};

export default Plus;
